module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOBAMAAAB8hD0uAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAD1BMVEVcOQmRYyM2HwFXFxEAAADpeE+SAAAAAWJLR0QEj2jZUQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAFdJREFUSMdjYCAEBAUFCaoZTuqGH1BSUsIUNDY2Hq7qyAuQYaAOnsQJGDBc1I2CkQYGS06jnjpkHfjKsuGibhQwgAOLqJQyBNXh14c93Q9ldcT7fVioAwBfFyF5nbIzAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/dirt.png
// module id = 453
// module chunks = 114276838955818